import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from 'react-redux';

import type { AppDispatch } from '@app/setup-store';
import type { StateType } from '@app/types/reducer-state';

// Assign (not useSelector.withTypes()) so these stay runtime-identical to react-redux and test mocks keep working.
export const useAppSelector: TypedUseSelectorHook<StateType> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
